const keyPrefix = "apply";

export const storage = {
  getItem: (key: string): string | null => localStorage.getItem(`${keyPrefix}.${key}`),
  setItem: (key: string, value: string): void => localStorage.setItem(`${keyPrefix}.${key}`, value),
  removeItem: (key: string): void => localStorage.removeItem(`${keyPrefix}.${key}`),
};
